// Above this many categories a donut's slices blur together; a ranked bar
// list reads better. Single source of truth for every widget.
export const BAR_THRESHOLD = 5

export const shouldUseBar = (
  segmentCount: number,
  threshold: number = BAR_THRESHOLD,
): boolean => segmentCount > threshold

// Collapse a row list to its first N unless expanded. Returns the original
// array reference when no collapsing is needed (cheap identity for callers).
export function sliceVisible<T>(
  rows: T[],
  initialVisible: number | undefined,
  expanded: boolean,
): T[] {
  if (initialVisible == null || expanded || rows.length <= initialVisible) {
    return rows
  }
  return rows.slice(0, initialVisible)
}

// Non-mutating descending sort by a numeric accessor. Bars are a ranking.
export function sortByValueDesc<T>(rows: T[], getValue: (row: T) => number): T[] {
  return [...rows].sort((a, b) => getValue(b) - getValue(a))
}
